export default __webpack_public_path__ + "static/media/evreuxmini.19a94421.jpg";